module.exports = __webpack_public_path__ + "media/images/category_icons/beauty-c40c867d1d12bc43b41d60272b4a4a05.svg";